import axios, { AxiosRequestConfig } from 'axios';
import { getS3Url } from 'src/util/getS3Url';

export const uploadToS3 = (config: AxiosRequestConfig<unknown>) => {
  return axios<unknown, unknown>({
    baseURL: getS3Url(),
    method: 'post',
    ...config,
  });
};
